var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { SvgAlertTriangle, SvgTickRound } from '@guardian/src-icons';
import { inlineError, inlineSuccess } from './styles';
export { userFeedbackDefault, userFeedbackBrand, } from '@guardian/src-foundations/themes';
const InlineError = (_a) => {
    var { children, cssOverrides } = _a, props = __rest(_a, ["children", "cssOverrides"]);
    return (_jsxs("span", Object.assign({ css: (theme) => [
            inlineError(theme.userFeedback && theme),
            cssOverrides,
        ] }, props, { children: [_jsx(SvgAlertTriangle, {}, void 0), children] }), void 0));
};
const InlineSuccess = (_a) => {
    var { children, cssOverrides } = _a, props = __rest(_a, ["children", "cssOverrides"]);
    return (_jsxs("span", Object.assign({ css: (theme) => [
            inlineSuccess(theme.userFeedback && theme),
            cssOverrides,
        ] }, props, { children: [_jsx(SvgTickRound, {}, void 0), children] }), void 0));
};
export { InlineError, InlineSuccess };
//# sourceMappingURL=index.js.map
